<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recover your password</h4>
                                    <p>Please enter your email address and we'll send you instructions on how to reset your password.</p>
                                </div>

                                <vs-input
                                  v-validate="'required|email'"
                                  data-vv-validate-on="blur"
                                  name="email"
                                  type="email"
                                  placeholder="Email"
                                  label-placeholder="Email"
                                  v-model="email"
                                  class="w-full mb-1" />
                                  <span class="text-danger text-sm my-8">{{ errors.first('email') }}</span>
<br><br>
                                <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Back To Login</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" :disabled="!validateForm"   @click="recoverPass()">Recover Password</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email : 'admin@yahoo.com'
        }
    },
    computed: {
      validateForm() {
        return !this.errors.any() && this.email != '';
      }
    },
    methods : {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },


    recoverPass() {
        if (!this.checkLogin()) return

      // Loading
      this.$vs.loading()

      const payload = {
        email: this.email,
      }

      this.$store.dispatch('auth/forgotPassword', payload)
        .then(response => { 
          this.$vs.loading.close()
          if(response.data.success)
          {
            this.$vs.notify({
                     title: 'Success',
                     text: response.data.message,
                     iconPack: 'feather',
                     icon: 'icon-check_box',
                     color: 'success'
             })
          }
          else {
            this.$vs.notify({
                     title: 'Error',
                     text: response.data.message,
                     iconPack: 'feather',
                     icon: 'icon-alert-circle',
                     color: 'danger'
             })
          }
          })
        .catch(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: 'Email doesn\'t exists',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }
    },


}
</script>
